import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    btn: {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        padding: theme.spacing(7),

        '&:hover': {
            backgroundColor: theme.palette.primary.hover
        }
    }
}));

export default useStyles;
